export class CarParkDriverEditModel {
  constructor ({ username = '', carParkId = -1, role = 0, after = null, before = null, restricted = false} = {}) {
    this.username = username
    this.car_park_id = carParkId
    this.role = role
    this.after = after
    this.before = before
    this.restricted = restricted
  }

  backendModel () {
    return {
      username: this.username,
      car_park_id: this.car_park_id,
      role: this.role,
      after: this.after,
      before: this.before,
      restricted: this.restricted
    }
  }
}
